const appLogo = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="addon">
      <rect
        width="31.5"
        height="31.5"
        transform="translate(0.25 0.25)"
        fill="white"
        fillOpacity="0.01"
      />
      <g id="Vector">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.048 8.07438L12.952 4.58238C13.843 4.05475 15.1604 4.057 16.048 4.58238L21.952 8.07438C22.843 8.60088 23.5 9.76975 23.5 10.8194V17.8056C23.5 18.8586 22.8396 20.0253 21.952 20.5506L16.048 24.0426C15.157 24.5703 13.8396 24.568 12.952 24.0426L7.048 20.5506C6.157 20.0241 5.5 18.8553 5.5 17.8056V10.8194C5.5 9.76638 6.16037 8.59975 7.048 8.07438ZM14.9117 6.59613C14.7261 6.48588 14.275 6.48588 14.0871 6.59613L8.18313 10.0881C7.99638 10.1984 7.77025 10.5989 7.77025 10.8194V17.8056C7.77025 18.025 7.99525 18.4255 8.18313 18.5369L14.0871 22.0289C14.2739 22.1391 14.725 22.1391 14.9129 22.0289L20.8169 18.5369C21.0036 18.4266 21.2298 18.0261 21.2298 17.8056V10.8194C21.2298 10.6 21.0047 10.1995 20.8169 10.0881L14.9117 6.59613Z"
          fill="#505F79"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 18.8125C13.3065 18.8125 12.1619 18.3384 11.318 17.4945C10.4741 16.6506 10 15.506 10 14.3125C10 13.119 10.4741 11.9744 11.318 11.1305C12.1619 10.2866 13.3065 9.8125 14.5 9.8125C15.6935 9.8125 16.8381 10.2866 17.682 11.1305C18.5259 11.9744 19 13.119 19 14.3125C19 15.506 18.5259 16.6506 17.682 17.4945C16.8381 18.3384 15.6935 18.8125 14.5 18.8125ZM14.5 16.5625C15.0967 16.5625 15.669 16.3254 16.091 15.9035C16.5129 15.4815 16.75 14.9092 16.75 14.3125C16.75 13.7158 16.5129 13.1435 16.091 12.7215C15.669 12.2996 15.0967 12.0625 14.5 12.0625C13.9033 12.0625 13.331 12.2996 12.909 12.7215C12.4871 13.1435 12.25 13.7158 12.25 14.3125C12.25 14.9092 12.4871 15.4815 12.909 15.9035C13.331 16.3254 13.9033 16.5625 14.5 16.5625Z"
          fill="#505F79"
        />
      </g>
    </g>
  </svg>
);

export { appLogo };
